import styled from "styled-components";
import StyledBadgeContent from "./styled_badge_content";
import * as colors from "themes/colors";

export default styled(StyledBadgeContent)`
  background-color: ${props => props.muiTheme.palette.secondary.dark};
  color: ${colors.white};
`;
